@if (reporte?.activo) {
  <!-- Loading -->
  @if (this.loading.getLoading()) {
    <mat-progress-bar
      mode="indeterminate"
      color="primary"
      style="margin-bottom: 8px"
    ></mat-progress-bar>
  }

  <div class="vehicle-details-container">
    <!-- Header con identificación -->
    <div class="vehicle-header">
      <h4 class="vehicle-title">
        {{ reporte?.activo?.identificacion }}
      </h4>
      <button
        irxBotonIcono
        (click)="deseleccionar()"
        tooltip="Deseleccionar vehículo"
        class="deselect-button"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="vehicle-content">
      <!-- Información del vehículo -->
      @if (reporte?.activo?.categoria === 'Vehículo') {
        <div class="vehicle-info">
          <table class="info-table">
            <tbody>
              <!-- Cliente -->
              @if (cliente?.tipoCliente !== 'Final') {
                <tr>
                  <td class="label">Cliente:</td>
                  <td class="value">
                    {{ reporte?.cliente?.nombre || 'No informado' }}
                  </td>
                </tr>
              }
              <!-- Flota -->
              @if (reporte?.activo?.grupo?.nombre) {
                <tr>
                  <td class="label">Flota:</td>
                  <td class="value">
                    {{ reporte?.activo?.grupo?.nombre }}
                  </td>
                </tr>
              }
              <!-- Tipo / Funcion -->
              @if (reporte?.activo?.vehiculo?.tipo) {
                <tr>
                  <td class="label">Tipo / Función:</td>
                  <td class="value">
                    {{
                      etiquetaTipoYFuncion(
                        reporte?.activo?.vehiculo?.tipo,
                        reporte?.activo?.funcion
                      )
                    }}
                  </td>
                </tr>
              }
              <!-- Marca / Modelo -->
              @if (reporte?.activo?.vehiculo?.marca) {
                <tr>
                  <td class="label">Marca / Modelo:</td>
                  <td class="value">
                    {{ reporte?.activo?.vehiculo?.marca }}
                    @if (reporte?.activo?.vehiculo?.modelo) {
                      - {{ reporte?.activo?.vehiculo?.modelo }}
                    }
                  </td>
                </tr>
              }
              <!-- Patente -->
              @if (reporte?.activo?.vehiculo?.patente) {
                <tr>
                  <td class="label">Patente:</td>
                  <td class="value">
                    <span class="patente">
                      {{
                        helper.formatPatente(reporte?.activo.vehiculo?.patente)
                      }}
                    </span>
                  </td>
                </tr>
              }
              <!-- Combustible -->
              @let combCap = reporte?.activo?.vehiculo?.capacidadCombustible;
              @if (combCap || nivelCombustible !== undefined) {
                <tr>
                  <td class="label">Combustible:</td>
                  <td class="value">
                    @if (nivelCombustible !== undefined && combCap) {
                      {{ nivelCombustible }} / {{ combCap }} L ({{
                        (nivelCombustible / combCap) * 100 | number: '1.0-0'
                      }}%)
                    } @else if (combCap) {
                      {{ combCap }} L
                    } @else {
                      {{ nivelCombustible }} L
                    }
                  </td>
                </tr>
              }
              <!-- Consumo promedio (sensor de combustible, últimos 30 días) -->
              @if (rendimiento) {
                <tr [tooltip]="rendimiento.detalle">
                  <td class="label">Consumo prom.:</td>
                  <td class="value">
                    @if (rendimiento.principal) {
                      {{ rendimiento.principal }}
                      @if (rendimiento.secundario) {
                        · {{ rendimiento.secundario }}
                      }
                      <span class="rendimiento-ventana">(30 días)</span>
                    } @else {
                      <span class="rendimiento-sin-datos">
                        {{ rendimiento.sinDatos }}
                      </span>
                    }
                  </td>
                </tr>
              }
              <!-- Temperatura de Carga -->
              @if (temperatura !== undefined) {
                <tr>
                  <td class="label">Temp. de Carga:</td>
                  <td class="value">
                    {{ temperatura > 0 ? '+' : '' }}{{ temperatura }} °C
                  </td>
                </tr>
              }
              <!-- Direccion -->
              @if (!helper.isValueMissing(reporte?.valores?.direccion)) {
                <tr [tooltip]="reporte?.valores?.direccion">
                  <td class="label">Dirección:</td>
                  <td class="value">
                    <div class="direccion-row">
                      <span>
                        {{
                          helper.extraerDireccion(reporte?.valores?.direccion)
                        }}
                      </span>
                      <button
                        irxBotonIcono
                        tono="primario"
                        tamano="mini"
                        class="btn-streetview"
                        tooltip="Ver Street View"
                        (click)="verStreetView()"
                      >
                        <mat-icon>streetview</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              }
              <!-- Ignicion / Velocidad -->
              @let tieneIgnicion =
                !helper.isValueMissing(reporte?.valores?.ignicion);
              @let tieneVelocidad =
                !helper.isValueMissing(reporte?.valores?.velocidad);
              @if (tieneIgnicion || tieneVelocidad) {
                <tr>
                  <td class="label">
                    @if (tieneIgnicion && tieneVelocidad) {
                      Ignición / Velocidad:
                    } @else if (tieneIgnicion) {
                      Ignición:
                    } @else {
                      Velocidad:
                    }
                  </td>
                  <td class="value">
                    <div class="ignicion">
                      @if (tieneIgnicion) {
                        <mat-icon
                          [style.color]="
                            reporte?.valores?.ignicion
                              ? 'var(--color-green-icon)'
                              : 'var(--color-red-icon)'
                          "
                        >
                          {{ reporte?.valores?.ignicion ? 'key' : 'key_off' }}
                        </mat-icon>
                      }

                      @if (tieneVelocidad) {
                        <span>
                          {{ reporte?.valores?.velocidad | number: '1.0-0' }}
                          km/h
                        </span>
                      }
                    </div>
                  </td>
                </tr>
              }
              <!-- Conductor -->
              @if (chofer) {
                <tr>
                  <td class="label">Conductor:</td>
                  <td class="value">
                    <div class="conductor-row">
                      <span>
                        {{ chofer.datosPersonales?.nombre || chofer.usuario }}
                      </span>
                      @if (chofer.datosPersonales?.foto) {
                        <img
                          [src]="chofer.datosPersonales.foto"
                          [alt]="chofer.datosPersonales?.nombre"
                          class="conductor-avatar conductor-avatar-clickable irx-clickeable"
                          role="button"
                          tabindex="0"
                          (click)="showChoferViewer = true"
                          (keydown.enter)="showChoferViewer = true"
                          title="Ver foto completa"
                        />
                        <app-image-viewer
                          [imageUrl]="chofer.datosPersonales.foto"
                          [isVisible]="showChoferViewer"
                          [altText]="chofer.datosPersonales?.nombre"
                          (closeViewer)="showChoferViewer = false"
                        ></app-image-viewer>
                      } @else {
                        <mat-icon class="conductor-avatar-icon">
                          person
                        </mat-icon>
                      }
                    </div>
                  </td>
                </tr>
              }
              <!-- Fecha -->
              @if (reporte?.valores?.timestamp) {
                <tr>
                  <td class="label">Fecha reporte:</td>
                  <td class="value">
                    {{
                      reporte?.valores?.timestamp | date: 'dd/MM/yyyy HH:mm:ss'
                    }}
                  </td>
                </tr>
              }
            </tbody>
          </table>

          <!-- Cumplimiento del recorrido asignado (real vs deseado) -->
          @if (cumplimiento) {
            <div class="cumplimiento-recorrido">
              <div class="cumplimiento-header">
                <span class="cumplimiento-titulo">
                  <mat-icon>checklist</mat-icon>
                  <span class="cumplimiento-nombre" [tooltip]="nombreRecorrido">
                    {{ nombreRecorrido || 'Recorrido' }}
                  </span>
                  @if (cumplimiento.numeroVuelta > 1) {
                    <small>vuelta {{ cumplimiento.numeroVuelta }}</small>
                  }
                </span>
                <span
                  class="cumplimiento-estado"
                  [class.desviado]="cumplimiento.estado === 'Desviado'"
                  [class.completado]="cumplimiento.estado === 'Completado'"
                >
                  {{ cumplimiento.estado }}
                </span>
              </div>

              <mat-progress-bar
                mode="determinate"
                [color]="colorCumplimiento"
                [value]="cumplimiento.porcentajeCobertura ?? 0"
              ></mat-progress-bar>

              <div class="cumplimiento-datos">
                <b>{{ cumplimiento.porcentajeCobertura | number: '1.0-1' }}%</b>
                <span>
                  {{ kmCubiertos | number: '1.1-1' }} /
                  {{ kmTotales | number: '1.1-1' }} km
                </span>
                @if (cumplimiento.estado === 'Desviado') {
                  <span class="desviado">
                    a {{ cumplimiento.distanciaAlRecorrido }} m de la traza
                  </span>
                }
              </div>

              @if (cumplimiento.porTiempo && cumplimiento.estadoTiempo) {
                <div class="cumplimiento-datos">
                  <span
                    [class.desviado]="cumplimiento.estadoTiempo === 'Atrasado'"
                  >
                    {{ cumplimiento.estadoTiempo }}
                    @if (cumplimiento.desvioMinutos) {
                      ({{ cumplimiento.desvioMinutos > 0 ? '+' : ''
                      }}{{ cumplimiento.desvioMinutos | number: '1.0-0' }} min)
                    }
                  </span>
                  <span>
                    {{ cumplimiento.duracionMinutos | number: '1.0-0' }} de
                    {{ cumplimiento.duracionEsperada }} min
                  </span>
                </div>
              }

              @if (cumplimiento.metrosFueraDeRuta) {
                <small class="cumplimiento-fuera">
                  {{ cumplimiento.metrosFueraDeRuta / 1000 | number: '1.1-1' }}
                  km fuera de la traza
                </small>
              }
            </div>
          }

          <!-- Botones de acciones rápidas -->
          <div class="actions-container">
            <button
              irxBotonIcono
              tono="primario"
              tooltip="Asignar recorrido"
              (click)="asignarRecorrido()"
            >
              <mat-icon>route</mat-icon>
            </button>

            <button
              irxBotonIcono
              tono="primario"
              tooltip="Editar"
              (click)="editar(reporte.activo)"
            >
              <mat-icon>edit</mat-icon>
            </button>

            <button
              irxBotonIcono
              tono="primario"
              tooltip="Detalles"
              [routerLink]="['../vehiculos/detalles', reporte.activo?._id]"
            >
              <mat-icon>visibility</mat-icon>
            </button>

            @if (puedeCrearRegla()) {
              <button
                irxBotonIcono
                tono="primario"
                tooltip="Crear regla de evento"
                (click)="crearRegla()"
              >
                <mat-icon>rule</mat-icon>
              </button>
            }

            @if (cumplimiento) {
              <button
                irxBotonIcono
                tono="primario"
                tooltip="Reiniciar la medición del recorrido"
                (click)="reiniciarCumplimiento()"
              >
                <mat-icon>restart_alt</mat-icon>
              </button>
            }

            @if (idRecorridoDinamicoAsignado) {
              <button
                irxBotonIcono
                tono="primario"
                tooltip="Finalizar recorrido dinámico"
                (click)="finalizarRecorridoDinamico()"
              >
                <mat-icon>task_alt</mat-icon>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
